var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Primary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24px",
    "data-name": "24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(-1075.505 -97.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1093.168,104.536l-.171.1-.171.1v-.393l.17.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M1093.711,116.712a1.866,1.866,0,0,1-.181.1A1.988,1.988,0,0,0,1093.711,116.712Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M1094.6,104.109v8.805a4,4,0,0,1-.38,1.7,3.824,3.824,0,0,0,.324-1.239h-.842a3.156,3.156,0,0,0,.035-.457v-5.127h-12.366v8.032a.328.328,0,0,0,.328.328h8.8a2.816,2.816,0,0,0,.514-.044v.846a3.923,3.923,0,0,0,1.29-.367,4.011,4.011,0,0,1-1.8.428h-8.8a1.193,1.193,0,0,1-1.191-1.191v-11.71a1.193,1.193,0,0,1,1.191-1.191h1.718v1.273a.5.5,0,0,0,.5.492h.418a.492.492,0,0,0,.492-.492v-1.273h1.066v1.273a.493.493,0,0,0,.5.492h.414a.492.492,0,0,0,.5-.492v-1.273h.807v1.273a.493.493,0,0,0,.5.492h.414a.493.493,0,0,0,.5-.492v-1.273h.769v1.273a.492.492,0,0,0,.492.492h.418a.5.5,0,0,0,.5-.492v-1.273h1.722A1.193,1.193,0,0,1,1094.6,104.109Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M1094.595,113.538a3.772,3.772,0,0,1-3.361,3.41v-3.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 1.136,
    height: 2.854,
    rx: 0.401,
    transform: "translate(1085.974 101.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    d: "M.4,0H.739a.4.4,0,0,1,.4.4V2.454a.4.4,0,0,1-.4.4H.4a.4.4,0,0,1-.4-.4V.4A.4.4,0,0,1,.4,0Z",
    transform: "translate(1083.549 101.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    d: "M.4,0H.739a.4.4,0,0,1,.4.4V2.454a.4.4,0,0,1-.4.4H.4a.4.4,0,0,1-.4-.4V.4A.4.4,0,0,1,.4,0Z",
    transform: "translate(1088.239 101.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    d: "M.4,0H.739a.4.4,0,0,1,.4.4v2.06a.4.4,0,0,1-.4.4H.4a.4.4,0,0,1-.4-.4V.4A.4.4,0,0,1,.4,0Z",
    transform: "translate(1090.404 101.68)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "BoundingBox",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.d3ccd976.svg";
export { ForwardRef as ReactComponent };